import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 1280 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1280 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check\"><defs><style></style></defs><path d=\"M1124.346 16.13l-701.91 727.123L136.68 449.942 0 602.922 422.436 1024l850.985-867.709z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol